<div class="default-layout">
    <sp-default-header></sp-default-header>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <sp-default-footer></sp-default-footer>
</div>